<template>
  <div class="six" id="six">
    <div class="title">
      <div class="left-box"></div>
      <div class="right-box">工单处理情况分析</div>
    </div>
    <div class="three-header" id="headers">
      <div class="t-h-left">
        <Space wrap>
          <RadioGroup v-model="radio1" type="button" button-style="solid" @on-change="onInput(radio1)">
            <Radio label="今日"></Radio>
            <Radio label="本周"></Radio>
            <Radio label="本月"></Radio>
          </RadioGroup>
        </Space>
      </div>
      <div class="t-h-center">
        <Space size="large" wrap>
          <DatePicker :options="options" type="daterange" placement="bottom-end" placeholder="选择时间" style="width: 250px"
            clearable="true" @on-change="handleDateChange" />
        </Space>
      </div>
      <div class="t-h-right">
        <Button type="primary" class="middle-ca" @click="load()">搜索</Button>
      </div>
    </div>
    <div class="main" id="main-box1"></div>
  </div>
</template>

<script>
import moment from "moment";
import * as echarts from 'echarts';
import dayjs from "dayjs";
export default {
  data() {
    return {
      radio1: "本月",
      value1: "",
      myChart: "",
      data: {
        begin: "",
        end: "",
      },
      xAxisArr: [],
      yAxisArr: [],
      options: {
        disabledDate: (date) => {
          if (this.endMonth) {
            let endDate = this.getDate(this.endMonth);
            return (date && date > endDate) || date > new Date();
          } else {
            return date && date > new Date();
          }
        },
      },
    };
  },
  mounted() {
    this.onMonth();
  },
  methods: {
    handleDateChange(date) {
      const startDate = moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
      const endDate = moment(date[1]).format("YYYY-MM-DD HH:mm:ss");
      this.data.begin = startDate;
      this.data.end = endDate;
    },
    onInput(e) {
      switch (e) {
        case "本月":
          this.onMonth();
          break;
        case "本周":
          this.onWeek();
          break;
        case "今日":
          this.onDay();
          break;
        default:
          break;
      }
    },
    onMonth() {
      let beginMonth = dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss");
      let endMonth = dayjs().endOf("month").format("YYYY-MM-DD HH:mm:ss");
      this.data.begin = beginMonth;
      this.data.end = endMonth;
      this.load();
    },
    onWeek() {
      let beginWeek = dayjs().startOf("week").format("YYYY-MM-DD HH:mm:ss");
      let endWeek = dayjs().endOf("week").format("YYYY-MM-DD HH:mm:ss");
      this.data.begin = beginWeek;
      this.data.end = endWeek;
      this.load();
    },
    onDay() {
      let beginDay = dayjs().startOf("date").format("YYYY-MM-DD HH:mm:ss");
      let endDay = dayjs().endOf("date").format("YYYY-MM-DD HH:mm:ss");
      this.data.begin = beginDay;
      this.data.end = endDay;
      this.load();
    },
    load() {
      $utils.api.load("StateworkDisposeNew", this.data, "get").then((res) => {
        let that = this;
        if (res.code == 200) {
          that.yAxisArr = [res.data.response, res.data.disponse, res.data.allTime, res.data.bestTime];
          this.echartsFun();
        }
      });
    },
    echartsFun() {
      this.autoContainer()
      let chartMain = document.getElementById("main-box1");
      this.myChart = echarts.init(chartMain);
      let option = {
        grid: {
          left: "8%",
          right: "2%",
          top: "8%",
          bottom: "10%",
        },
        xAxis: {
          type: "category",
          data: ["平均响应时间", "平均处理时间", "平均总耗时", "最长耗时"],
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#999",
            },
          },
          axisLabel: {
            interval: 0,
            fontSize: 14,
            color: "#000",
            margin: 0,
            padding: [8, 0, 0, 0],
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100,
          // max: (value) => {
          //   if (value.max < 80) {
          //     return value.max = 80
          //   } else {
          //     return
          //   }
          // },
          interval: 10,
          axisLabel: {
            color: "#666",
            verticalAlign: "middle",
            formatter: "{value}.00",
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted",
              color: ['#ccc', '#ccc', '#ccc', '#ccc', '#ccc', '#ccc', 'red', '#ccc', '#ccc', '#ccc', '#ccc']
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            data: this.yAxisArr,
            type: "bar",
            barMaxWidth: "120",
            label: {
              show: true,
              position: "top",
              formatter: '{c}分钟'
            },
            itemStyle: {
              color: (params) => {
                if (params.data > 60) {
                  return params.color = {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: 'rgba(242, 91, 91, 1)' // 0% 处的颜色
                    }, {
                      offset: 0.5, color: 'rgba(64, 158, 255, 0.5)' // 0% 处的颜色
                    }, {
                      offset: 1, color: 'rgba(64, 158, 255, 1)' // 100% 处的颜色
                    }],
                    global: false // 缺省为 false
                  }
                } else {
                  return params.color = {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: 'rgba(64, 158, 255, 0.1)' // 0% 处的颜色
                    }, {
                      offset: 1, color: 'rgba(64, 158, 255, 1)' // 100% 处的颜色
                    }],
                    global: false // 缺省为 false
                  }
                }
              }
              // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              //   { offset: 0, color: "rgba(64, 158, 255, 0.1)" },
              //   { offset: 0.5, color: "rgba(64, 158, 255, 0.5)" },
              //   { offset: 1, color: "rgba(64, 158, 255, 1)" },
              // ]),
            },
          },
        ],
      };
      option && this.myChart.setOption(option);
      window.addEventListener('resize', () => {
        this.autoContainer()
        this.myChart.resize()
      })
    },
    autoContainer() {
      let chartMains = document.getElementById("main-box1");
      chartMains.style.width = document.getElementById("six").clientWidth - 20 + "px"
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.myChart.resize()
    })
  }
};
</script>

<style scoped lang="less">
.six {
  width: 100%;
  height: 330px;
  padding: 10px;

  .title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .left-box {
      width: 10px;
      height: 20px;
      border-radius: 1px;
      margin-right: 8px;
      background-color: #46a6ff;
    }

    .right-box {
      font-weight: 600;
      color: black;
    }
  }

  .three-header {
    margin-bottom: 10px;
    display: flex;
    width: 100%;

    .t-h-center {
      margin: 0 10px;
    }
  }

  .main {
    // width: 46%;
    height: 240px;
    background: #fff;
  }
}

.ivu-radio-group-button-solid .ivu-radio-wrapper-checked:not(.ivu-radio-wrapper-disabled) {
  background: #46a6ff;
  color: #fff;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked {
  border-color: #46a6ff;
  box-shadow: -1px 0 0 0 #46a6ff;
  z-index: 1;
}

.ivu-radio-group-button .ivu-radio-wrapper:hover {
  position: relative;
  color: #46a6ff;
}

.ivu-radio-group-button-solid .ivu-radio-wrapper-checked:not(.ivu-radio-wrapper-disabled):hover {
  background: #46a6ff;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked:hover {
  border-color: #46a6ff;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus {
  box-shadow: none;
  transition: none;
}

.iwu-btn-primary:focus {
  box-shadow: none;
}

.ivu-btn:focus {
  box-shadow: none;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked:before {
  background: none;
  opacity: 0;
}

.ivu-radio-group-button .ivu-radio-wrapper:before,
.ivu-radio-group-button .ivu-radio-wrapper:after {
  background: none;
  transition: none;
}

.ivu-radio-group-button .ivu-radio-wrapper:after {
  background: none;
  opacity: 0;
}

.ivu-radio-group-button .ivu-radio-wrapper:before,
.ivu-radio-group-button .ivu-radio-wrapper:after {
  background: none;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked:first-child {
  border-color: #46a6ff;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus:first-child {
  box-shadow: none;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus:after {
  opacity: 0;
}
</style>
